import Navbar from "react-bootstrap/Navbar";

const Header = () => {
  return (
    <Navbar
      className="mb-5 px-3 px-md-5 "
      style={{
        backgroundColor: "#555af8",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        paddingTop: "0.9rem",
        paddingBottom: "1rem",
      }}
    >
      <Navbar.Brand style={{ display: "flex", alignItems: "center" }}>
        <a
          href="https://portal.auteminvestimentos.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          className="mx-2 mx-md-0"
        >
          <img
            alt="Autem logo"
            src="./assets/autem.svg"
            width="300"
            height="55"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </a>
      </Navbar.Brand>
    </Navbar>
  );
};

export default Header;
